import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import roleService from '../services/roleService';

const AdminRolesPage = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [userId, setUserId] = useState('');
  const [roleName, setRoleName] = useState('participant');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const allRoles = await roleService.listRoles();
        setRoles(allRoles);
        if (allRoles.length > 0) {
          setRoleName(allRoles[0].name);
        }
      } catch (err) {
        setError('Failed to load roles');
      }
    };

    loadRoles();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!userId || !roleName) {
      setError('User ID and role are required');
      return;
    }

    try {
      setLoading(true);
      await roleService.assignRole({ userId, roleName });
      setMessage('Role assigned successfully');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to assign role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="competition-list-page">
      <div className="competition-content" style={{ maxWidth: 800, margin: '0 auto' }}>
        <div className="competition-header">
          <div>
            <h1>Assign Roles</h1>
            <p>Assign an active role to a user by user ID.</p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="dashboard-card" style={{ padding: 24 }}>
          {message && <p style={{ color: '#067647', marginBottom: 12 }}>{message}</p>}
          {error && <p style={{ color: '#b42318', marginBottom: 12 }}>{error}</p>}

          <div className="form-group">
            <label>User ID</label>
            <input value={userId} onChange={(e) => setUserId(e.target.value)} placeholder="Enter user id" required />
          </div>

          <div className="form-group">
            <label>Role</label>
            <select value={roleName} onChange={(e) => setRoleName(e.target.value)}>
              {roles.map((role) => (
                <option key={role.id || role.name} value={role.name}>
                  {role.displayName || role.name}
                </option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            <button className="action-button primary" type="submit" disabled={loading}>
              {loading ? 'Assigning...' : 'Assign Role'}
            </button>
            <button className="action-button" type="button" onClick={() => navigate('/dashboard')}>
              Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminRolesPage;
